import {
  DatasetConfig, DatasetConfigMutable, DatasetType, MultiCamMedia, SubType,
} from 'dive-common/apispec';

/**
 * Static properties loaded from the girder folder data/metadata
 */
interface GirderConfigStatic extends DatasetConfigMutable {
  /**
   * Required fields
   * Everything copied from DatasetConfig except imageData and videoUrl
   */
  id: Readonly<string>;
  name: Readonly<string>;
  createdAt: Readonly<string>;
  type: Readonly<DatasetType>;
  fps: Readonly<number>;
  annotate: Readonly<boolean>;
  subType: Readonly<SubType>;
  multiCamMedia: Readonly<MultiCamMedia | null>;

  /* optional */
  originalFps?: number;
  ffprobe_info?: Record<string, string>;
  foreign_media_id?: string;
  /** Girder item id of the optional per-dataset metadata file. */
  metadataFileItemId?: string;
  /** Original filename of the optional per-dataset metadata file. */
  metadataFileOriginalName?: string;
}

/**
 * Full metadata including dynamic properties (image list, video url)
 */
type GirderConfig = DatasetConfig & GirderConfigStatic;

const fileSuffixRegex = /\.[^.]*$/;

export {
  fileSuffixRegex,
};

export type {
  GirderConfigStatic,
  GirderConfig,
};
